import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // Skip on cart/checkout pages
    if (window.location.pathname.match(/\/(cart|checkout|payment)/)) return

    // Check localStorage for dismissal cooldown (7 days)
    const dismissedAt = localStorage.getItem("email_popup_dismissed")
    if (dismissedAt) {
      const dismissedTime = parseInt(dismissedAt, 10)
      const sevenDays = 7 * 24 * 60 * 60 * 1000
      if (Date.now() - dismissedTime < sevenDays) return
    }

    // Show after 5 second delay
    this.timer = setTimeout(() => this.show(), 5000)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
    document.body.style.overflow = ""
  }

  show() {
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  dismiss() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
    localStorage.setItem("email_popup_dismissed", Date.now().toString())
  }

  backdropClick(event) {
    if (event.target === this.overlayTarget) {
      this.dismiss()
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.dismiss()
    }
  }

  submitted() {
    document.body.style.overflow = ""
    localStorage.setItem("email_popup_dismissed", Date.now().toString())
  }
}
